import { Delete as DeleteIcon } from "@mui/icons-material";
import { Edit as EditIcon } from "@mui/icons-material";
import { PlaylistAdd as PlaylistAddIcon } from "@mui/icons-material";
import type { MenuOptionType } from "../../../../../controls/contextMenu/models/MenuOptionType";
import type { CatalogPourbackReason } from "../../../models/CatalogPourbackReason";

type Props = {
  setPourback: (pourback: CatalogPourbackReason) => void;
  setShowModal: (show: "new" | "edit" | "delete" | "") => void;
  handleNewPourback: () => void;
};

export const usePourbackOptionsFunctions = ({
  setPourback,
  setShowModal,
  handleNewPourback,
}: Props) => {
  const getMenuOptions = (data: CatalogPourbackReason) => {
    let options: MenuOptionType[] = [
      {
        name: "New PB Reason",
        key: "new_pourback_reason",
        onClick: () => {
          handleNewPourback();
        },
        icon: <PlaylistAddIcon />,
      },
    ];
    if (data) {
      options = options.concat([
        {
          name: "Edit PB Reason",
          key: "edit_pourback_reason",
          onClick: () => {
            setPourback(data);
            setShowModal("edit");
          },
          icon: <EditIcon />,
        },
        {
          name: "Delete PB Reason",
          key: "delete_pourback_reason",
          onClick: () => {
            setPourback(data);
            setShowModal("delete");
          },
          icon: <DeleteIcon />,
        },
      ]);
    }
    return options;
  };
  return {
    getMenuOptions,
  };
};
